module.exports = __webpack_public_path__ + "img/block-5.2295f446.svg";